import React, { useEffect } from 'react';
import LoadingScreen from 'src/components/LoadingScreen';
import withErrorBoundary from 'src/hocs/withErrorBoundary';
import useSessionContext from 'src/hooks/useSessionContext';

const Logout = () => {
  const { logout } = useSessionContext();

  useEffect(() => {
    logout();
  }, []);

  return <LoadingScreen />;
};

export default withErrorBoundary(Logout);
